import situation from './situation'

export default {
  situation,
}
